export default __webpack_public_path__ + "static/media/Large_printing_rules_inches.6730892c.pdf";